import {
  CalendarDays,
  LayoutDashboard,
  Music4,
  Settings,
  UsersRound,
  Wrench,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: typeof LayoutDashboard
  /** `end` so `/` does not stay highlighted on every child route. */
  end?: boolean
  description: string
  /** Minimum role that should see this destination at all. */
  minRole?: 'member' | 'viewer' | 'scheduler' | 'admin'
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Home', icon: LayoutDashboard, end: true, description: 'The dates you are serving' },
  { to: '/plans', label: 'Service Plans', icon: CalendarDays, description: 'Matrix and order of service' },
  { to: '/songs', label: 'Song Library', icon: Music4, description: 'Songs, keys and arrangements' },
  { to: '/schedule', label: 'Volunteers', icon: UsersRound, description: 'Who is serving, their status and blockouts' },
  { to: '/teams', label: 'Teams', icon: Wrench, description: 'Ministries, teams and positions' },
  { to: '/admin', label: 'Admin', icon: Settings, description: 'Public API, keys and simulation', minRole: 'admin' },
]

/** The destinations a given role should be offered. */
export function navItemsFor(role: string): NavItem[] {
  const rank: Record<string, number> = { member: 1, viewer: 2, scheduler: 3, admin: 4 }
  const have = rank[role] ?? 1
  return NAV_ITEMS.filter((item) => have >= (rank[item.minRole ?? 'member'] ?? 1))
}
